import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Offcanvas, OffcanvasBody } from 'reactstrap';
import { useSelector } from "react-redux";
import user_avatar from "../assets/img/core-img/default-avatar.webp";

const Sidebar = ({ handleShow, show }: any) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showShop, setShowShop] = useState(false);
    const location = useLocation();
    const authUser = useSelector((state: any) => state.auth?.user);

    const sidebarImage = user_avatar;
    const sidebarName = authUser?.name || "Thông tin tài khoản";

    useEffect(() => {
        if (!show) {
            setShowMenu(false);
            setShowShop(false);
        }
    }, [show]);

    useEffect(() => {
        if (location.pathname.startsWith("/menu")) {
            setShowMenu(true);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (location.pathname.startsWith("/shop")) {
            setShowShop(true);
        }
    }, [location.pathname]);

    return (
        <React.Fragment>
            <Offcanvas
                isOpen={show}
                toggle={handleShow}
                direction="start"
                className="suha-offcanvas-wrap"
            >
                <button
                    onClick={handleShow}
                    className="btn-close btn-close-white"
                ></button>

                <OffcanvasBody>
                    <div className="sidenav-profile">
                        <div className="user-profile ratio ratio-1x1" style={{ width: 80 }}>
                            <img
                                src={sidebarImage}
                                alt={sidebarName}
                                className="img-fluid object-fit-cover rounded-circle"
                            />
                        </div>
                        <div className="user-info">
                            <h5 className="user-name mb-1 text-white">{sidebarName}</h5>
                            <p className="available-balance text-white">
                                Quản lý
                            </p>
                        </div>
                    </div>

                    <ul className="sidenav-nav ps-0">

                        {/* THỰC ĐƠN */}
                        <li className="suha-dropdown-menu">
                            <Link to="/menu">
                                <i className="mdi mdi-menu"></i>Thực đơn
                            </Link>
                            <ul className={showMenu ? "d-block" : "d-none"}>
                                <li>
                                    <Link to="/menu" onClick={handleShow}>Danh sách</Link>
                                </li>
                                <li>
                                    <Link to="/menu/categories" onClick={handleShow}>Danh mục</Link>
                                </li>
                                <li>
                                    <Link to="/menu/options" onClick={handleShow}>Tùy chọn</Link>
                                </li>
                                <li>
                                    <Link to="/menu/import" onClick={handleShow}>Nhập nhanh</Link>
                                </li>
                            </ul>
                            <div
                                className="dropdown-trigger-btn"
                                onClick={() => setShowMenu(!showMenu)}
                            >
                                <i className={showMenu ? "mdi mdi-arrow-up" : "mdi mdi-arrow-down"}></i>
                            </div>
                        </li>

                        {/* QUÁN */}
                        <li className="suha-dropdown-menu">
                            <Link to="/shop/info">
                                <i className="mdi mdi-storefront-outline"></i>Quán
                            </Link>
                            <ul className={showShop ? "d-block" : "d-none"}>
                                <li>
                                    <Link to="/shop/info" onClick={handleShow}>Thông tin quán</Link>
                                </li>
                                <li>
                                    <Link to="/shop/zones" onClick={handleShow}>Khu vực & bàn</Link>
                                </li>
                                <li>
                                    <Link to="/shop/members" onClick={handleShow}>Thành viên</Link>
                                </li>
                                <li>
                                    <Link to="/shop/wifi" onClick={handleShow}>Wi-Fi</Link>
                                </li>
                                <li>
                                    <Link to="/shop/qr" onClick={handleShow}>Mã QR</Link>
                                </li>
                                <li>
                                    <Link to="/shop/qr/check" onClick={handleShow}>Kiểm tra mã QR</Link>
                                </li>
                            </ul>
                            <div
                                className="dropdown-trigger-btn"
                                onClick={() => setShowShop(!showShop)}
                            >
                                <i className={showShop ? "mdi mdi-arrow-up" : "mdi mdi-arrow-down"}></i>
                            </div>
                        </li>

                        <li>
                            <Link to="/subscription" onClick={handleShow}>
                                <i className="mdi mdi-credit-card-outline"></i>Đăng ký gói
                            </Link>
                        </li>

                        <li>
                            <Link to="/settings/notifications" onClick={handleShow}>
                                <i className="mdi mdi-bell-outline"></i>Thông báo
                            </Link>
                        </li>

                        <li>
                            <Link to="/settings/feedback" onClick={handleShow}>
                                <i className="mdi mdi-message-text-outline"></i>Góp ý phần mềm
                            </Link>
                        </li>

                        <li>
                            <Link to="/contact" onClick={handleShow}>
                                <i className="mdi mdi-phone-outline"></i>Liên hệ
                            </Link>
                        </li>

                        <li>
                            <Link to="/settings/change-password" onClick={handleShow}>
                                <i className="mdi mdi-lock-reset"></i>Đổi mật khẩu
                            </Link>
                        </li>

                        {/* LOGOUT */}
                        <li>
                            <Link to="/logout" onClick={handleShow}>
                                <i className="mdi mdi-logout"></i>Đăng xuất
                            </Link>
                        </li>
                    </ul>
                </OffcanvasBody>
            </Offcanvas>
        </React.Fragment>
    );
};

export default Sidebar;
